var qe = Object.defineProperty, Je = Object.defineProperties;
var Qe = Object.getOwnPropertyDescriptors;
var te = Object.getOwnPropertySymbols;
var ke = Object.prototype.hasOwnProperty, Ne = Object.prototype.propertyIsEnumerable;
var Ae = Math.pow, Re = (r, e, t) => e in r ? qe(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t, c = (r, e) => {
  for (var t in e || (e = {}))
    ke.call(e, t) && Re(r, t, e[t]);
  if (te)
    for (var t of te(e))
      Ne.call(e, t) && Re(r, t, e[t]);
  return r;
}, h = (r, e) => Je(r, Qe(e));
var N = (r, e) => {
  var t = {};
  for (var s in r)
    ke.call(r, s) && e.indexOf(s) < 0 && (t[s] = r[s]);
  if (r != null && te)
    for (var s of te(r))
      e.indexOf(s) < 0 && Ne.call(r, s) && (t[s] = r[s]);
  return t;
};
import { jsx as p, jsxs as F, Fragment as Ye } from "react/jsx-runtime";
import { forwardRef as ae, useState as be, useRef as E, createElement as Ge, useEffect as Ze } from "react";
import { e as ve, a as er, c as U, b as rr } from "./get-size-Bc1Pz5yf.js";
import { c as Z } from "./create-vars-resolver-Bzbn9G-G.js";
import { f as ne, u as P, B as O, b as tr } from "./factory-ueRxoNOV.js";
import { u as W } from "./use-styles-DToiHEa6.js";
import { p as He } from "./polymorphic-factory-DufevJAl.js";
import { L as sr } from "./Loader-DVuQGvNU.js";
import { T as or } from "./Transition-esp-rpzm.js";
import { U as ar } from "./UnstyledButton-D9OCzDhz.js";
import { r as _ } from "./rem-CMQJ_ZTp.js";
import { c as nr } from "./create-optional-context-CQ2ahjKQ.js";
import { u as Ve, c as Fe } from "./use-move-d_9eZhab.js";
import { u as he } from "./use-reduced-motion-C9DbPZfj.js";
import { u as cr } from "./use-merged-ref-n551Tfbr.js";
import { u as ir } from "./use-uncontrolled-BT_j5D2R.js";
var q = { root: "m_8d3f4000", icon: "m_8d3afb97", loader: "m_302b9fb1", group: "m_1a0f1b21", groupSection: "m_437b6484" };
const Pe = {
  orientation: "horizontal"
}, lr = Z((r, { borderWidth: e }) => ({
  group: { "--ai-border-width": _(e) }
})), fe = ne((r, e) => {
  const t = P("ActionIconGroup", Pe, r), f = P("ActionIconGroup", Pe, r), {
    className: s,
    style: o,
    classNames: n,
    styles: a,
    unstyled: i,
    orientation: m,
    vars: l,
    borderWidth: b,
    variant: y,
    mod: S
  } = f, d = N(f, [
    "className",
    "style",
    "classNames",
    "styles",
    "unstyled",
    "orientation",
    "vars",
    "borderWidth",
    "variant",
    "mod"
  ]), u = W({
    name: "ActionIconGroup",
    props: t,
    classes: q,
    className: s,
    style: o,
    classNames: n,
    styles: a,
    unstyled: i,
    vars: l,
    varsResolver: lr,
    rootSelector: "group"
  });
  return /* @__PURE__ */ p(
    O,
    c(h(c({}, u("group")), {
      ref: e,
      variant: y,
      mod: [{ "data-orientation": m }, S],
      role: "group"
    }), d)
  );
});
fe.classes = q;
fe.displayName = "@mantine/core/ActionIconGroup";
const Ce = {}, dr = Z(
  (r, { radius: e, color: t, gradient: s, variant: o, autoContrast: n, size: a }) => {
    const i = r.variantColorResolver({
      color: t || r.primaryColor,
      theme: r,
      gradient: s,
      variant: o || "filled",
      autoContrast: n
    });
    return {
      groupSection: {
        "--section-height": U(a, "section-height"),
        "--section-padding-x": U(a, "section-padding-x"),
        "--section-fz": er(a),
        "--section-radius": e === void 0 ? void 0 : ve(e),
        "--section-bg": t || o ? i.background : void 0,
        "--section-color": i.color,
        "--section-bd": t || o ? i.border : void 0
      }
    };
  }
), ye = ne((r, e) => {
  const t = P("ActionIconGroupSection", Ce, r), f = P("ActionIconGroupSection", Ce, r), {
    className: s,
    style: o,
    classNames: n,
    styles: a,
    unstyled: i,
    vars: m,
    variant: l,
    gradient: b,
    radius: y,
    autoContrast: S
  } = f, d = N(f, [
    "className",
    "style",
    "classNames",
    "styles",
    "unstyled",
    "vars",
    "variant",
    "gradient",
    "radius",
    "autoContrast"
  ]), u = W({
    name: "ActionIconGroupSection",
    props: t,
    classes: q,
    className: s,
    style: o,
    classNames: n,
    styles: a,
    unstyled: i,
    vars: m,
    varsResolver: dr,
    rootSelector: "groupSection"
  });
  return /* @__PURE__ */ p(O, c(h(c({}, u("groupSection")), { ref: e, variant: l }), d));
});
ye.classes = q;
ye.displayName = "@mantine/core/ActionIconGroupSection";
const ur = {}, hr = Z(
  (r, { size: e, radius: t, variant: s, gradient: o, color: n, autoContrast: a }) => {
    const i = r.variantColorResolver({
      color: n || r.primaryColor,
      theme: r,
      gradient: o,
      variant: s || "filled",
      autoContrast: a
    });
    return {
      root: {
        "--ai-size": U(e, "ai-size"),
        "--ai-radius": t === void 0 ? void 0 : ve(t),
        "--ai-bg": n || s ? i.background : void 0,
        "--ai-hover": n || s ? i.hover : void 0,
        "--ai-hover-color": n || s ? i.hoverColor : void 0,
        "--ai-color": i.color,
        "--ai-bd": n || s ? i.border : void 0
      }
    };
  }
), ce = He((r, e) => {
  const t = P("ActionIcon", ur, r), T = t, {
    className: s,
    unstyled: o,
    variant: n,
    classNames: a,
    styles: i,
    style: m,
    loading: l,
    loaderProps: b,
    size: y,
    color: S,
    radius: d,
    __staticSelector: u,
    gradient: f,
    vars: w,
    children: C,
    disabled: R,
    "data-disabled": $,
    autoContrast: g,
    mod: k
  } = T, I = N(T, [
    "className",
    "unstyled",
    "variant",
    "classNames",
    "styles",
    "style",
    "loading",
    "loaderProps",
    "size",
    "color",
    "radius",
    "__staticSelector",
    "gradient",
    "vars",
    "children",
    "disabled",
    "data-disabled",
    "autoContrast",
    "mod"
  ]), z = W({
    name: ["ActionIcon", u],
    props: t,
    className: s,
    style: m,
    classes: q,
    classNames: a,
    styles: i,
    unstyled: o,
    vars: w,
    varsResolver: hr
  });
  return /* @__PURE__ */ F(
    ar,
    h(c(c({}, z("root", { active: !R && !l && !$ })), I), {
      unstyled: o,
      variant: n,
      size: y,
      disabled: R || l,
      ref: e,
      mod: [{ loading: l, disabled: R || $ }, k],
      children: [
        /* @__PURE__ */ p(or, { mounted: !!l, transition: "slide-down", duration: 150, children: (J) => /* @__PURE__ */ p(O, h(c({ component: "span" }, z("loader", { style: J })), { "aria-hidden": !0, children: /* @__PURE__ */ p(sr, c({ color: "var(--ai-color)", size: "calc(var(--ai-size) * 0.55)" }, b)) })) }),
        /* @__PURE__ */ p(O, h(c({ component: "span", mod: { loading: l } }, z("icon")), { children: C }))
      ]
    })
  );
});
ce.classes = q;
ce.displayName = "@mantine/core/ActionIcon";
ce.Group = fe;
ce.GroupSection = ye;
var De = { root: "m_de3d2490", colorOverlay: "m_862f3d1b", shadowOverlay: "m_98ae7f22", alphaOverlay: "m_95709ac0", childrenOverlay: "m_93e74e3" };
const Ie = {
  withShadow: !0
}, mr = Z((r, { radius: e, size: t }) => ({
  root: {
    "--cs-radius": e === void 0 ? void 0 : ve(e),
    "--cs-size": _(t)
  }
})), ie = He((r, e) => {
  const t = P("ColorSwatch", Ie, r), C = P("ColorSwatch", Ie, t), {
    classNames: s,
    className: o,
    style: n,
    styles: a,
    unstyled: i,
    vars: m,
    color: l,
    size: b,
    radius: y,
    withShadow: S,
    children: d,
    variant: u
  } = C, f = N(C, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "color",
    "size",
    "radius",
    "withShadow",
    "children",
    "variant"
  ]), w = W({
    name: "ColorSwatch",
    props: t,
    classes: De,
    className: o,
    style: n,
    classNames: s,
    styles: a,
    unstyled: i,
    vars: m,
    varsResolver: mr
  });
  return /* @__PURE__ */ F(
    O,
    h(c(c({
      ref: e,
      variant: u,
      size: b
    }, w("root", { focusable: !0 })), f), {
      children: [
        /* @__PURE__ */ p("span", c({}, w("alphaOverlay"))),
        S && /* @__PURE__ */ p("span", c({}, w("shadowOverlay"))),
        /* @__PURE__ */ p("span", c({}, w("colorOverlay", { style: { backgroundColor: l } }))),
        /* @__PURE__ */ p("span", h(c({}, w("childrenOverlay")), { children: d }))
      ]
    })
  );
});
ie.classes = De;
ie.displayName = "@mantine/core/ColorSwatch";
const [pr, ge] = nr(null), Se = ae((s, t) => {
  var o = s, { position: r } = o, e = N(o, ["position"]);
  return /* @__PURE__ */ p(
    O,
    c({
      ref: t,
      __vars: {
        "--thumb-y-offset": `${r.y * 100}%`,
        "--thumb-x-offset": `${r.x * 100}%`
      }
    }, e)
  );
});
Se.displayName = "@mantine/core/ColorPickerThumb";
var we = { wrapper: "m_fee9c77", preview: "m_9dddfbac", body: "m_bffecc3e", sliders: "m_3283bb96", thumb: "m_40d572ba", swatch: "m_d8ee6fd8", swatches: "m_5711e686", saturation: "m_202a296e", saturationOverlay: "m_11b3db02", slider: "m_d856d47d", sliderOverlay: "m_8f327113" };
const br = {}, xe = ne((r, e) => {
  var re;
  const t = P("ColorSlider", br, r), B = t, {
    classNames: s,
    className: o,
    style: n,
    styles: a,
    unstyled: i,
    vars: m,
    onChange: l,
    onChangeEnd: b,
    maxValue: y,
    round: S,
    size: d = "md",
    focusable: u = !0,
    value: f,
    overlays: w,
    thumbColor: C = "transparent",
    onScrubStart: R,
    onScrubEnd: $,
    __staticSelector: g = "ColorPicker"
  } = B, k = N(B, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "onChange",
    "onChangeEnd",
    "maxValue",
    "round",
    "size",
    "focusable",
    "value",
    "overlays",
    "thumbColor",
    "onScrubStart",
    "onScrubEnd",
    "__staticSelector"
  ]), I = W({
    name: g,
    classes: we,
    props: t,
    className: o,
    style: n,
    classNames: s,
    styles: a,
    unstyled: i
  }), T = ((re = ge()) == null ? void 0 : re.getStyles) || I, J = tr(), [G, D] = be({ y: 0, x: f / y }), H = E(G), L = (v) => S ? Math.round(v * y) : v * y, { ref: Q } = Ve(
    ({ x: v, y: M }) => {
      H.current = { x: v, y: M }, l == null || l(L(v));
    },
    {
      onScrubEnd: () => {
        const { x: v } = H.current;
        b == null || b(L(v)), $ == null || $();
      },
      onScrubStart: R
    }
  );
  he(() => {
    D({ y: 0, x: f / y });
  }, [f]);
  const j = (v, M) => {
    v.preventDefault();
    const K = Fe(M);
    l == null || l(L(K.x)), b == null || b(L(K.x));
  }, ee = (v) => {
    switch (v.key) {
      case "ArrowRight": {
        j(v, { x: G.x + 0.05, y: G.y });
        break;
      }
      case "ArrowLeft": {
        j(v, { x: G.x - 0.05, y: G.y });
        break;
      }
    }
  }, Y = w.map((v, M) => /* @__PURE__ */ Ge("div", h(c({}, T("sliderOverlay")), { style: v, key: M })));
  return /* @__PURE__ */ F(
    O,
    h(c(h(c({}, k), {
      ref: cr(Q, e)
    }), T("slider")), {
      role: "slider",
      "aria-valuenow": f,
      "aria-valuemax": y,
      "aria-valuemin": 0,
      tabIndex: u ? 0 : -1,
      onKeyDown: ee,
      "data-focus-ring": J.focusRing,
      __vars: {
        "--cp-thumb-size": `var(--cp-thumb-size-${d})`
      },
      children: [
        Y,
        /* @__PURE__ */ p(
          Se,
          c({
            position: G
          }, T("thumb", { style: { top: _(1), background: C } }))
        )
      ]
    })
  );
});
xe.displayName = "@mantine/core/ColorSlider";
function A(r, e = 0, t = Ae(10, e)) {
  return Math.round(t * r) / t;
}
function vr({ h: r, s: e, l: t, a: s }) {
  const o = e * ((t < 50 ? t : 100 - t) / 100);
  return {
    h: r,
    s: o > 0 ? 2 * o / (t + o) * 100 : 0,
    v: t + o,
    a: s
  };
}
const fr = {
  grad: 360 / 400,
  turn: 360,
  rad: 360 / (Math.PI * 2)
};
function yr(r, e = "deg") {
  return Number(r) * (fr[e] || 1);
}
const gr = /hsla?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i;
function Oe(r) {
  const e = gr.exec(r);
  return e ? vr({
    h: yr(e[1], e[2]),
    s: Number(e[3]),
    l: Number(e[4]),
    a: e[5] === void 0 ? 1 : Number(e[5]) / (e[6] ? 100 : 1)
  }) : { h: 0, s: 0, v: 0, a: 1 };
}
function me({ r, g: e, b: t, a: s }) {
  const o = Math.max(r, e, t), n = o - Math.min(r, e, t), a = n ? o === r ? (e - t) / n : o === e ? 2 + (t - r) / n : 4 + (r - e) / n : 0;
  return {
    h: A(60 * (a < 0 ? a + 6 : a), 3),
    s: A(o ? n / o * 100 : 0, 3),
    v: A(o / 255 * 100, 3),
    a: s
  };
}
function pe(r) {
  const e = r[0] === "#" ? r.slice(1) : r;
  return e.length === 3 ? me({
    r: parseInt(e[0] + e[0], 16),
    g: parseInt(e[1] + e[1], 16),
    b: parseInt(e[2] + e[2], 16),
    a: 1
  }) : me({
    r: parseInt(e.slice(0, 2), 16),
    g: parseInt(e.slice(2, 4), 16),
    b: parseInt(e.slice(4, 6), 16),
    a: 1
  });
}
function Sr(r) {
  const e = r[0] === "#" ? r.slice(1) : r, t = (a) => A(parseInt(a, 16) / 255, 3);
  if (e.length === 4) {
    const a = e.slice(0, 3), i = t(e[3] + e[3]);
    return h(c({}, pe(a)), { a: i });
  }
  const s = e.slice(0, 6), o = t(e.slice(6, 8));
  return h(c({}, pe(s)), { a: o });
}
const wr = /rgba?\(?\s*(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i;
function Me(r) {
  const e = wr.exec(r);
  return e ? me({
    r: Number(e[1]) / (e[2] ? 100 / 255 : 1),
    g: Number(e[3]) / (e[4] ? 100 / 255 : 1),
    b: Number(e[5]) / (e[6] ? 100 / 255 : 1),
    a: e[7] === void 0 ? 1 : Number(e[7]) / (e[8] ? 100 : 1)
  }) : { h: 0, s: 0, v: 0, a: 1 };
}
const Le = {
  hex: /^#?([0-9A-F]{3}){1,2}$/i,
  hexa: /^#?([0-9A-F]{4}){1,2}$/i,
  rgb: /^rgb\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/i,
  rgba: /^rgba\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/i,
  hsl: /hsl\(\s*(\d+)\s*,\s*(\d+(?:\.\d+)?%)\s*,\s*(\d+(?:\.\d+)?%)\)/i,
  hsla: /^hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*(\d*(?:\.\d+)?)\)$/i
}, xr = {
  hex: pe,
  hexa: Sr,
  rgb: Me,
  rgba: Me,
  hsl: Oe,
  hsla: Oe
};
function $r(r) {
  for (const [, e] of Object.entries(Le))
    if (e.test(r))
      return !0;
  return !1;
}
function se(r) {
  if (typeof r != "string")
    return { h: 0, s: 0, v: 0, a: 1 };
  if (r === "transparent")
    return { h: 0, s: 0, v: 0, a: 0 };
  const e = r.trim();
  for (const [t, s] of Object.entries(Le))
    if (s.test(e))
      return xr[t](e);
  return { h: 0, s: 0, v: 0, a: 1 };
}
const _r = {}, Ue = ae((r, e) => {
  const i = P(
    "AlphaSlider",
    _r,
    r
  ), { value: t, onChange: s, onChangeEnd: o, color: n } = i, a = N(i, ["value", "onChange", "onChangeEnd", "color"]);
  return /* @__PURE__ */ p(
    xe,
    h(c({}, a), {
      ref: e,
      value: t,
      onChange: (m) => s == null ? void 0 : s(A(m, 2)),
      onChangeEnd: (m) => o == null ? void 0 : o(A(m, 2)),
      maxValue: 1,
      round: !1,
      "data-alpha": !0,
      overlays: [
        {
          backgroundImage: "linear-gradient(45deg, var(--slider-checkers) 25%, transparent 25%), linear-gradient(-45deg, var(--slider-checkers) 25%, transparent 25%), linear-gradient(45deg, transparent 75%, var(--slider-checkers) 75%), linear-gradient(-45deg, var(--mantine-color-body) 75%, var(--slider-checkers) 75%)",
          backgroundSize: `${_(8)} ${_(8)}`,
          backgroundPosition: `0 0, 0 ${_(4)}, ${_(4)} ${_(-4)}, ${_(-4)} 0`
        },
        {
          backgroundImage: `linear-gradient(90deg, transparent, ${n})`
        },
        {
          boxShadow: `rgba(0, 0, 0, .1) 0 0 0 ${_(1)} inset, rgb(0, 0, 0, .15) 0 0 ${_(
            4
          )} inset`
        }
      ]
    })
  );
});
Ue.displayName = "@mantine/core/AlphaSlider";
function je({ h: r, s: e, v: t, a: s }) {
  const o = r / 360 * 6, n = e / 100, a = t / 100, i = Math.floor(o), m = a * (1 - n), l = a * (1 - (o - i) * n), b = a * (1 - (1 - o + i) * n), y = i % 6;
  return {
    r: A([a, l, m, m, b, a][y] * 255),
    g: A([b, a, a, l, m, m][y] * 255),
    b: A([m, m, b, a, a, l][y] * 255),
    a: A(s, 2)
  };
}
function ze(r, e) {
  const { r: t, g: s, b: o, a: n } = je(r);
  return e ? `rgba(${t}, ${s}, ${o}, ${A(n, 2)})` : `rgb(${t}, ${s}, ${o})`;
}
function Te({ h: r, s: e, v: t, a: s }, o) {
  const n = (200 - e) * t / 100, a = {
    h: Math.round(r),
    s: Math.round(n > 0 && n < 200 ? e * t / 100 / (n <= 100 ? n : 200 - n) * 100 : 0),
    l: Math.round(n / 2)
  };
  return o ? `hsla(${a.h}, ${a.s}%, ${a.l}%, ${A(s, 2)})` : `hsl(${a.h}, ${a.s}%, ${a.l}%)`;
}
function oe(r) {
  const e = r.toString(16);
  return e.length < 2 ? `0${e}` : e;
}
function Be(r) {
  const { r: e, g: t, b: s } = je(r);
  return `#${oe(e)}${oe(t)}${oe(s)}`;
}
function Rr(r) {
  const e = Math.round(r.a * 255);
  return `${Be(r)}${oe(e)}`;
}
const ue = {
  hex: Be,
  hexa: (r) => Rr(r),
  rgb: (r) => ze(r, !1),
  rgba: (r) => ze(r, !0),
  hsl: (r) => Te(r, !1),
  hsla: (r) => Te(r, !0)
};
function V(r, e) {
  return e ? r in ue ? ue[r](e) : ue.hex(e) : "#000000";
}
const Ke = ae((r, e) => {
  const i = P("HueSlider", {}, r), { value: t, onChange: s, onChangeEnd: o, color: n } = i, a = N(i, ["value", "onChange", "onChangeEnd", "color"]);
  return /* @__PURE__ */ p(
    xe,
    h(c({}, a), {
      ref: e,
      value: t,
      onChange: s,
      onChangeEnd: o,
      maxValue: 360,
      thumbColor: `hsl(${t}, 100%, 50%)`,
      round: !0,
      "data-hue": !0,
      overlays: [
        {
          backgroundImage: "linear-gradient(to right,hsl(0,100%,50%),hsl(60,100%,50%),hsl(120,100%,50%),hsl(170,100%,50%),hsl(240,100%,50%),hsl(300,100%,50%),hsl(360,100%,50%))"
        },
        {
          boxShadow: `rgba(0, 0, 0, .1) 0 0 0 ${_(1)} inset, rgb(0, 0, 0, .15) 0 0 ${_(
            4
          )} inset`
        }
      ]
    })
  );
});
Ke.displayName = "@mantine/core/HueSlider";
function Xe(y) {
  var S = y, {
    className: r,
    onChange: e,
    onChangeEnd: t,
    value: s,
    saturationLabel: o,
    focusable: n = !0,
    size: a,
    color: i,
    onScrubStart: m,
    onScrubEnd: l
  } = S, b = N(S, [
    "className",
    "onChange",
    "onChangeEnd",
    "value",
    "saturationLabel",
    "focusable",
    "size",
    "color",
    "onScrubStart",
    "onScrubEnd"
  ]);
  const { getStyles: d } = ge(), [u, f] = be({ x: s.s / 100, y: 1 - s.v / 100 }), w = E(u), { ref: C } = Ve(
    ({ x: g, y: k }) => {
      w.current = { x: g, y: k }, e({ s: Math.round(g * 100), v: Math.round((1 - k) * 100) });
    },
    {
      onScrubEnd: () => {
        const { x: g, y: k } = w.current;
        t({ s: Math.round(g * 100), v: Math.round((1 - k) * 100) }), l == null || l();
      },
      onScrubStart: m
    }
  );
  Ze(() => {
    f({ x: s.s / 100, y: 1 - s.v / 100 });
  }, [s.s, s.v]);
  const R = (g, k) => {
    g.preventDefault();
    const I = Fe(k);
    e({ s: Math.round(I.x * 100), v: Math.round((1 - I.y) * 100) }), t({ s: Math.round(I.x * 100), v: Math.round((1 - I.y) * 100) });
  }, $ = (g) => {
    switch (g.key) {
      case "ArrowUp": {
        R(g, { y: u.y - 0.05, x: u.x });
        break;
      }
      case "ArrowDown": {
        R(g, { y: u.y + 0.05, x: u.x });
        break;
      }
      case "ArrowRight": {
        R(g, { x: u.x + 0.05, y: u.y });
        break;
      }
      case "ArrowLeft": {
        R(g, { x: u.x - 0.05, y: u.y });
        break;
      }
    }
  };
  return /* @__PURE__ */ F(
    O,
    h(c(h(c({}, d("saturation")), {
      ref: C
    }), b), {
      role: "slider",
      "aria-label": o,
      "aria-valuenow": u.x,
      "aria-valuetext": V("rgba", s),
      tabIndex: n ? 0 : -1,
      onKeyDown: $,
      children: [
        /* @__PURE__ */ p(
          "div",
          c({}, d("saturationOverlay", {
            style: { backgroundColor: `hsl(${s.h}, 100%, 50%)` }
          }))
        ),
        /* @__PURE__ */ p(
          "div",
          c({}, d("saturationOverlay", {
            style: { backgroundImage: "linear-gradient(90deg, #fff, transparent)" }
          }))
        ),
        /* @__PURE__ */ p(
          "div",
          c({}, d("saturationOverlay", {
            style: { backgroundImage: "linear-gradient(0deg, #000, transparent)" }
          }))
        ),
        /* @__PURE__ */ p(Se, c({ position: u }, d("thumb", { style: { backgroundColor: i } })))
      ]
    })
  );
}
Xe.displayName = "@mantine/core/Saturation";
const Ee = ae(
  (b, l) => {
    var y = b, {
      className: r,
      datatype: e,
      setValue: t,
      onChangeEnd: s,
      size: o,
      focusable: n,
      data: a,
      swatchesPerRow: i
    } = y, m = N(y, [
      "className",
      "datatype",
      "setValue",
      "onChangeEnd",
      "size",
      "focusable",
      "data",
      "swatchesPerRow"
    ]);
    const S = ge(), d = a.map((u, f) => /* @__PURE__ */ Ge(
      ie,
      h(c({}, S.getStyles("swatch")), {
        unstyled: S.unstyled,
        component: "button",
        type: "button",
        color: u,
        key: f,
        radius: "sm",
        onClick: () => {
          t(u), s == null || s(u);
        },
        "aria-label": u,
        tabIndex: n ? 0 : -1,
        "data-swatch": !0
      })
    ));
    return /* @__PURE__ */ p(O, h(c(h(c({}, S.getStyles("swatches")), { ref: l }), m), { children: d }));
  }
);
Ee.displayName = "@mantine/core/Swatches";
const kr = {
  swatchesPerRow: 7,
  withPicker: !0,
  focusable: !0,
  size: "md",
  __staticSelector: "ColorPicker"
}, Nr = Z((r, { size: e, swatchesPerRow: t }) => ({
  wrapper: {
    "--cp-preview-size": U(e, "cp-preview-size"),
    "--cp-width": U(e, "cp-width"),
    "--cp-body-spacing": rr(e),
    "--cp-swatch-size": `${100 / t}%`,
    "--cp-thumb-size": U(e, "cp-thumb-size"),
    "--cp-saturation-height": U(e, "cp-saturation-height")
  }
})), We = ne((r, e) => {
  const t = P("ColorPicker", kr, r), $e = t, {
    classNames: s,
    className: o,
    style: n,
    styles: a,
    unstyled: i,
    vars: m,
    format: l,
    value: b,
    defaultValue: y,
    onChange: S,
    onChangeEnd: d,
    withPicker: u,
    size: f,
    saturationLabel: w,
    hueLabel: C,
    alphaLabel: R,
    focusable: $,
    swatches: g,
    swatchesPerRow: k,
    fullWidth: I,
    onColorSwatchClick: z,
    __staticSelector: T,
    mod: J
  } = $e, G = N($e, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "format",
    "value",
    "defaultValue",
    "onChange",
    "onChangeEnd",
    "withPicker",
    "size",
    "saturationLabel",
    "hueLabel",
    "alphaLabel",
    "focusable",
    "swatches",
    "swatchesPerRow",
    "fullWidth",
    "onColorSwatchClick",
    "__staticSelector",
    "mod"
  ]), D = W({
    name: T,
    props: t,
    classes: we,
    className: o,
    style: n,
    classNames: s,
    styles: a,
    unstyled: i,
    rootSelector: "wrapper",
    vars: m,
    varsResolver: Nr
  }), H = E(l), L = E(""), Q = E(-1), j = E(!1), ee = l === "hexa" || l === "rgba" || l === "hsla", [Y, B, re] = ir({
    value: b,
    defaultValue: y,
    finalValue: "#FFFFFF",
    onChange: S
  }), [v, M] = be(se(Y)), K = () => {
    window.clearTimeout(Q.current), j.current = !0;
  }, le = () => {
    window.clearTimeout(Q.current), Q.current = window.setTimeout(() => {
      j.current = !1;
    }, 200);
  }, de = (x) => {
    M((X) => {
      const _e = c(c({}, X), x);
      return L.current = V(H.current, _e), _e;
    }), B(L.current);
  };
  return he(() => {
    $r(b) && !j.current && M(se(b));
  }, [b]), he(() => {
    H.current = l, B(V(l, v));
  }, [l]), /* @__PURE__ */ p(pr, { value: { getStyles: D, unstyled: i }, children: /* @__PURE__ */ F(
    O,
    h(c(h(c({
      ref: e
    }, D("wrapper")), {
      size: f,
      mod: [{ "full-width": I }, J]
    }), G), {
      children: [
        u && /* @__PURE__ */ F(Ye, { children: [
          /* @__PURE__ */ p(
            Xe,
            {
              value: v,
              onChange: de,
              onChangeEnd: ({ s: x, v: X }) => d == null ? void 0 : d(V(H.current, h(c({}, v), { s: x, v: X }))),
              color: Y,
              size: f,
              focusable: $,
              saturationLabel: w,
              onScrubStart: K,
              onScrubEnd: le
            }
          ),
          /* @__PURE__ */ F("div", h(c({}, D("body")), { children: [
            /* @__PURE__ */ F("div", h(c({}, D("sliders")), { children: [
              /* @__PURE__ */ p(
                Ke,
                {
                  value: v.h,
                  onChange: (x) => de({ h: x }),
                  onChangeEnd: (x) => d == null ? void 0 : d(V(H.current, h(c({}, v), { h: x }))),
                  size: f,
                  focusable: $,
                  "aria-label": C,
                  onScrubStart: K,
                  onScrubEnd: le
                }
              ),
              ee && /* @__PURE__ */ p(
                Ue,
                {
                  value: v.a,
                  onChange: (x) => de({ a: x }),
                  onChangeEnd: (x) => {
                    d == null || d(V(H.current, h(c({}, v), { a: x })));
                  },
                  size: f,
                  color: V("hex", v),
                  focusable: $,
                  "aria-label": R,
                  onScrubStart: K,
                  onScrubEnd: le
                }
              )
            ] })),
            ee && /* @__PURE__ */ p(
              ie,
              c({
                color: Y,
                radius: "sm",
                size: "var(--cp-preview-size)"
              }, D("preview"))
            )
          ] }))
        ] }),
        Array.isArray(g) && /* @__PURE__ */ p(
          Ee,
          {
            data: g,
            swatchesPerRow: k,
            focusable: $,
            setValue: B,
            onChangeEnd: (x) => {
              const X = V(l, se(x));
              z == null || z(X), d == null || d(X), re || M(se(x));
            }
          }
        )
      ]
    })
  ) });
});
We.classes = we;
We.displayName = "@mantine/core/ColorPicker";
export {
  ce as A,
  ie as C,
  We as a,
  V as c,
  $r as i,
  se as p
};
